module.exports = __webpack_public_path__ + "img/ycclogo.eed53c6c.png";